import { Button as ButtonAntd } from 'antd';
import styled from 'styled-components';

import colors from '../../../../styles/colors/index';

export const TabContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const GridDados = styled.div`
  font-size: 14px;
  margin-bottom: 1px;
  margin-top: 1px;

  p {
    color: ${colors.dark_blue};
    font-weight: 700;
    line-height: 22px;
  }

  span {
    color: ${colors.gray_2};
    letter-spacing: 0.025em;
    line-height: 18px;
  }
`;

export const GridDadosItem = styled.div`
  gap: 8px;
`;

export const GridDadosItemText = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: ${props => (props.regular ? 400 : 600)};
  font-size: 16px;
  line-height: 150%;
  color: ${props =>
    props.regular ? colors.$greyscale_dark_grey_10 : colors.$greyscale_black_5};
  margin-bottom: 8px;
`;

export const GridTitle = styled.div`
  font-family: 'Inter';
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 1px;
  margin-top: 20px;

  p {
    font-family: 'Inter';
    color: ${colors.dark_blue};
    font-weight: 700;
    line-height: 22px;
  }
`;

export const Button = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: ${colors.$light};
  padding: 5px 16px 5px 16px;
  border: 1px solid ${colors.tmov_green};
  border-radius: 2px !important;
  background: ${colors.tmov_green};

  margin-left: 5px;
  margin-right: 5px;
  margin-top: 15px;

  &:hover,
  &:focus,
  &:active {
    color: ${colors.$light};
    border-color: ${colors.light_green};
    background-color: ${colors.light_green};
  }
`;

export const Duplicar = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: ${colors.tmov_green};
  padding: 5px 16px 5px 16px;
  border: 1px solid transparent;
  background: transparent;

  margin-left: 5px;
  margin-right: 5px;

  &:hover,
  &:focus,
  &:active {
    color: ${colors.tmov_green};
  }
`;

export const GridButton = styled.div`
  position: absolute;
  right: 0;
  margin-right: 20px;
`;

export const GridRotas = styled.div`
  font-size: 14px;
  margin-bottom: 15px;
  margin-top: 15px;

  span {
    color: ${colors.gray_2};
    letter-spacing: 0.025em;
    line-height: 18px;
  }
`;

export const GridRotaItem = styled.div`
  font-size: 14px;

  span {
    color: ${colors.gray_2};
    letter-spacing: 0.025em;
    line-height: 20px;

    margin-bottom: 20px;

    span {
      border: 1px solid ${colors.tmov_green};
      width: 20px;
      height: 20px;

      margin: 0px 10px 0px 13px;
    }
  }

  p {
    color: ${colors.dark_blue};
    font-weight: 700;
    margin-bottom: 0;

    span {
      height: 8px;
      width: 8px;
      background-color: ${colors.tmov_green};
      border-radius: 50%;
      display: inline-block;

      margin: 0px 10px;
    }
  }

  &:last-child {
    span {
      span {
        border: 1px solid transparent;
        width: 10px;
        height: 10px;

        margin: 0px 10px 0px 13px;
      }
    }
  }
`;

export const Origem = styled.div``;

export const Destino = styled.div``;

export const Text = styled.p`
  margin-bottom: 8px;
`;
